import {
    GET_USER, GET_USER_FAILED, RESET_SIGN_IN_ERROR_MESSAGE, SIGN_OUT, LOADING_USER, POST_USER
} from "./type";
import UsersService from "../../services/usersService";
import { Auth } from "aws-amplify";

export const getUser = () => async (dispatch) => {
    try {
        dispatch({
            type: LOADING_USER,
            payload: true
        })
        const response = await UsersService.getUser();

        if (response.data.Data.isPhotographer === null || response.data.Data.isPhotographer === undefined || response.data.Data.isPhotographer === false) {
            await Auth.currentAuthenticatedUser().then(async (user) => {
                const userAttributes = await Auth.userAttributes(user);
                const isPhotographerAttribute = userAttributes.find(
                    attr => attr.Name === 'custom:is_photographer'
                );

                if (!isPhotographerAttribute) {
                    await Auth.updateUserAttributes(user, {
                        'custom:is_photographer': 'true'
                    });
                }
                response.data.Data.isPhotographer = true;
                if (response.data.Data.totalBalance === null || response.data.Data.totalBalance === 0 || response.data.Data.totalBalance === "0") {
                    response.data.Data.totalBalance = 100;
                }

                var newUser = await UsersService.postUser(response.data.Data);
                newUser.data.balance = getBalance(newUser.data.totalBalance, newUser.data.usedBalance);
                dispatch({
                    type: POST_USER,
                    payload: newUser.data
                });
            });

        } else {

            response.data.Data.balance = getBalance(response.data.Data.totalBalance, response.data.Data.usedBalance);

            dispatch({
                type: GET_USER,
                payload: response.data
            });
        }
    } catch (error) {
        console.log(error);
        // El cromo (raíl y cabecera) pinta esqueleto mientras no haya saldo; con el GET
        // caído tiene que volver al «—», no quedarse cargando para siempre.
        dispatch({ type: GET_USER_FAILED });
    } finally {
        dispatch({
            type: LOADING_USER,
            payload: false
        })
    }
};

export const postUser = (user) => async (dispatch) => {
    try {
        dispatch({
            type: LOADING_USER,
            payload: true
        })
        const userToUpdate = {
            ...user,
            isPhotographer: true
        };
        
        const response = await UsersService.postUser(userToUpdate);

        const balance = response.data.totalBalance - response.data.usedBalance;
        response.data.balance = balance.toString();

        dispatch({
            type: POST_USER,
            payload: response.data
        });
        // El thunk se come el error (no lanza), asi que devuelve si el guardado cuajo:
        // es la unica senal que tiene la pantalla para no quedarse esperando un
        // round-trip que nunca va a llegar.
        return true;
    } catch (error) {
        console.log(error);
        return false;
    } finally {
        dispatch({
            type: LOADING_USER,
            payload: false
        })
    }
};

export const signOut = () => async (dispatch) => {
    try {
        dispatch({
            type: LOADING_USER,
            payload: true
        })
        await UsersService.signOut();
        dispatch({
            type: SIGN_OUT,
            payload: {}
        });
    } catch (error) {
        console.log(error);
    } finally {
        dispatch({
            type: LOADING_USER,
            payload: false
        })
    }
};

export const deleteAccount = () => async (dispatch) => {
    try {
        dispatch({
            type: LOADING_USER,
            payload: true
        })
        await UsersService.deleteAccount();
        dispatch({
            type: SIGN_OUT,
            payload: {}
        });
    } catch (error) {
        console.log(error);
    } finally {
        dispatch({
            type: LOADING_USER,
            payload: false
        })
    }
}

export const resetErrorMessage = () => async (dispatch) => {
    dispatch({
        type: RESET_SIGN_IN_ERROR_MESSAGE
    });
};

const getBalance = (totalBalance, usedBalance) => {
    const balance = totalBalance - usedBalance;
    if (balance < 0) {
        return '0';
    } else {
        return balance.toString();
    }
}